import React, { Component } from 'react';
import moment from 'moment';

import Avatar from '../Avatar';
import Icon from '../Icon';
import Button from '../Button';
import TextEditor from '../Editor/Editor';
import { convertToDisplayText } from '../../helpers/validationHelper';
// import draftToHtml from 'draftjs-to-html';

/**
* @author
* @class MaintenanceGuiddeRepeater

**/


const MaintenanceGuiddeRepeater = ({from, onEdit,onDelete,maintenanceguides,onlyView }) => (
    <div>
       {maintenanceguides.map((maintenanceguide, x) => (
         <div
           key={x}
           className="notes__note"
         >
           <div className="notes__title">
             {maintenanceguide.appointment && (
               <>
                 [Reminder]
                 {' '}
               </>
             )}
             {maintenanceguide.title}
             {onlyView === true ? null : <div className="notes__actions">
               <Button
                 color="semantic"
                 onClick={ () => onEdit(maintenanceguide)}
                 label={(
                   <Icon
                     glyph="pencil"
                     weight="light"
                   />
                 )}
               />
               <Button
                 color="semantic"
                 onClick={ () => onDelete(maintenanceguide)}
                 label={(
                   <Icon
                     glyph="trash"
                     weight="light"
                   />
                 )}
               />
             </div>}
           </div>
           {maintenanceguide.appointment && (
             <div className="notes__appointment">
                 <Icon
                   glyph="calendar"
                   weight="solid"
                   size="medium"
                 />
               {from === 'Catalog'?
               maintenanceguide.IsSuiteWarrantyStartDate ? 
               <>{
                maintenanceguide.repeatType ? 'Repeat every ' + (maintenanceguide.repeatType === 'Custom' ? maintenanceguide.repeatEvery + ' ' + convertToDisplayText(maintenanceguide.repeatTypeEvery, maintenanceguide.repeatEvery) : convertToDisplayText(maintenanceguide.repeatType)) : ''
               }</>
              :
              <>{
              moment(maintenanceguide.appointment.date).format('dddd MM/DD/YYYY')}{' '}{moment(maintenanceguide.appointment.time).format('hh:mm A')}{maintenanceguide.repeatType ? ', ' + 'repeat every ' + (maintenanceguide.repeatType === 'Custom' ? maintenanceguide.repeatEvery + ' ' + convertToDisplayText(maintenanceguide.repeatTypeEvery, maintenanceguide.repeatEvery) : convertToDisplayText(maintenanceguide.repeatType)) : ''
              }</> 
               :
               maintenanceguide.IsSuiteWarrantyStartDate ?
               <>{
                moment(maintenanceguide.reminderDate).format('dddd MM/DD/YYYY')}{' '}{moment(maintenanceguide.time).format('hh:mm A')}{maintenanceguide.repeatType ? ', ' + 'repeat every ' + (maintenanceguide.repeatType === 'Custom' ? maintenanceguide.repeatEvery + ' ' + convertToDisplayText(maintenanceguide.repeatTypeEvery, maintenanceguide.repeatEvery) : convertToDisplayText(maintenanceguide.repeatType)) : ''
               }</>
               :
               <>{
                moment(maintenanceguide.appointment.date).format('dddd MM/DD/YYYY')}{' '}{moment(maintenanceguide.appointment.time).format('hh:mm A')}{maintenanceguide.repeatType ? ', ' + 'repeat every ' + (maintenanceguide.repeatType === 'Custom' ? maintenanceguide.repeatEvery + ' ' + convertToDisplayText(maintenanceguide.repeatTypeEvery, maintenanceguide.repeatEvery) : convertToDisplayText(maintenanceguide.repeatType)) : ''
               }</>
             }
             </div>
           )}
           <div className="notes__body">
            
             {/* {maintenanceguide.body} */}
          {/* {<div dangerouslySetInnerHTML={{__html: maintenanceguide.body}} />} */}
          <TextEditor
                            editorState={maintenanceguide.body}
                            readOnly={true}
                            toolbarHidden={true}
                          />
          </div>
           {/* <div className="notes__author">
             <div className="notes__avatar">
               <Avatar size="small" />
             </div> 
             <div className="notes__username">
               {maintenanceguide.author.firstName} {maintenanceguide.author.lastName}
             </div>
             <div className="notes__date">
               {moment(maintenanceguide.createdAt).format('MM/DD/YYYY hh:mm A')}
             </div>
           </div> */}
         </div>
       ))}
     </div>
   );


export default MaintenanceGuiddeRepeater
